import { render, staticRenderFns } from "./LiveSensorDisplay.vue?vue&type=template&id=5ea51017&scoped=true&"
import script from "./LiveSensorDisplay.vue?vue&type=script&lang=js&"
export * from "./LiveSensorDisplay.vue?vue&type=script&lang=js&"
import style0 from "./LiveSensorDisplay.vue?vue&type=style&index=0&id=5ea51017&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea51017",
  null
  
)

export default component.exports